if ($('.js_checkout').length) {
    const checkoutTools = {
        setDeliveryType(checkbox, isChangePayments) {
            if (checkbox) {
                checkoutTools.setDeliveryTypeItem(checkbox, isChangePayments)
            } else {
                const checkbox = $('input[type=radio][name=delivery]:checked')
                checkoutTools.setDeliveryTypeItem(checkbox, isChangePayments)
            }
        },

        setDeliveryTypeItem(checkbox, isChangePayments) {
            const delivery = checkbox.attr('value') >= 1 && checkbox.attr('value') <= 6 ? checkbox.attr('value') : 'default'

            if (delivery == '2' && $('.js_checkout__form-nova-post').length) {
                $(`.js_checkout_delivery_type`).each((i, el) => {
                    const wrapper = $(el)
                    const input = wrapper.find('input, textarea, select')
                    wrapper.addClass('disabled')
                    input.prop('disabled', true)
                })
                $('.js_checkout__form-nova-post').addClass('active')
            } else {
                $(`.js_checkout_delivery_type`).each((i, el) => {
                    const wrapper = $(el)
                    const input = wrapper.find('input, textarea')
                    const deliveries = wrapper.attr('data-delivery').split(',')
                    if (deliveries.includes(delivery)) {
                        wrapper.removeClass('disabled')
                        input.prop('disabled', false)
                    } else {
                        wrapper.addClass('disabled')
                        input.prop('disabled', true)
                    }
                })
                $('.js_checkout__form-nova-post').removeClass('active')
                $('.js_checkout__form-nova-post').find('input, textarea, select').prop('disabled', true)
            }

            if (isChangePayments) {
                const payments = checkbox.attr('data-payment').split(',')
                $('.js_checkout_payment').each((i, el) => {
                    const paymentInput = $(el).find('input[name=payment]')
                    const paymentValue = paymentInput.attr('value')
                    if (payments.includes(paymentValue)) {
                        $(el).removeClass('disabled')
                        paymentInput.prop('disabled', false)
                    } else {
                        $(el).addClass('disabled')
                        paymentInput.prop('disabled', true)
                    }
                })
                const paymentCheckedInput = $('.js_checkout_payment:not(.disabled)').first().find('input[name=payment]')
                paymentCheckedInput.prop('checked', true)
            }
        },
    }

    $(document).ready(function () {
        checkoutTools.setDeliveryType(null, true)
    })

    $(document).on('change', '.js_checkout_delivery input[name=delivery]', function () {
        checkoutTools.setDeliveryType($(this), true)
    })
}